const listClass = "list-disc pl-6 text-[#1F2937] mb-6 space-y-2";
const pClass = "text-[#1F2937] mb-4";

const privacyPolicyData = [
  {
    title: '1. Information We Collect',
    content: (
      <>
        <h3 className="text-xl font-bold text-[#0B2A57] mb-3 mt-6" style={{ fontFamily: 'Cabinet Grotesk' }}>
          Personal Information
        </h3>
        <p className={pClass}>When you contact us or request services, we may collect:</p>
        <ul className={listClass}>
          <li>Name and company name</li>
          <li>Email address and phone number</li>
          <li>Business address and shipping information</li>
          <li>Product specifications and order details</li>
          <li>Communication preferences</li>
        </ul>
        <h3 className="text-xl font-bold text-[#0B2A57] mb-3 mt-6" style={{ fontFamily: 'Cabinet Grotesk' }}>
          Automatically Collected Information
        </h3>
        <ul className={listClass}>
          <li>IP address and browser type</li>
          <li>Device information and operating system</li>
          <li>Pages visited and time spent on site</li>
          <li>Referring website and exit pages</li>
        </ul>
      </>
    ),
  },
  {
    title: '2. How We Use Your Information',
    content: (
      <>
        <p className={pClass}>We use collected information to:</p>
        <ul className={listClass}>
          <li>Process and fulfill your sourcing requests</li>
          <li>Communicate about orders, samples, and shipments</li>
          <li>Provide customer support and respond to inquiries</li>
          <li>Improve our services and website functionality</li>
          <li>Send relevant business updates and newsletters (with consent)</li>
          <li>Comply with legal obligations and prevent fraud</li>
        </ul>
      </>
    ),
  },
  {
    title: '3. Information Sharing',
    content: (
      <>
        <p className={pClass}>
          We do not sell, trade, or rent your personal information to third parties. We may share information with:
        </p>
        <ul className={listClass}>
          <li><strong>Manufacturing Partners:</strong> Only order-specific details necessary for production</li>
          <li><strong>Shipping Providers:</strong> Delivery information for order fulfillment</li>
          <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
          <li><strong>Service Providers:</strong> Email services, analytics tools (with appropriate data protection agreements)</li>
        </ul>
      </>
    ),
  },
  {
    title: '4. Data Security',
    content: (
      <>
        <p className="text-[#1F2937] mb-6">We implement industry-standard security measures to protect your information:</p>
        <ul className={listClass}>
          <li>Secure SSL encryption for data transmission</li>
          <li>Password-protected access to sensitive systems</li>
          <li>Regular security audits and updates</li>
          <li>Limited employee access on a need-to-know basis</li>
          <li>Confidentiality agreements with all partners and employees</li>
        </ul>
      </>
    ),
  },
  {
    title: '5. Cookies and Tracking',
    content: (
      <>
        <p className={pClass}>We use cookies and similar technologies to:</p>
        <ul className={listClass}>
          <li>Remember your preferences and settings</li>
          <li>Analyze site traffic and user behavior</li>
          <li>Improve user experience and website functionality</li>
        </ul>
        <p className="text-[#1F2937] mb-6">
          You can control cookie preferences through your browser settings. Note that disabling cookies may affect website functionality.
        </p>
      </>
    ),
  },
  {
    title: '6. Your Rights',
    content: (
      <>
        <p className={pClass}>You have the right to:</p>
        <ul className={listClass}>
          <li><strong>Access:</strong> Request a copy of your personal data</li>
          <li><strong>Correction:</strong> Update or correct inaccurate information</li>
          <li><strong>Deletion:</strong> Request deletion of your data (subject to legal obligations)</li>
          <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
          <li><strong>Data Portability:</strong> Receive your data in a structured format</li>
        </ul>
        <p className="text-[#1F2937] mb-6">To exercise these rights, contact us at info@taigasourcing.com</p>
      </>
    ),
  },
  {
    title: '7. Data Retention',
    content: (
      <>
        <p className="text-[#1F2937] mb-6">We retain your information for as long as necessary to:</p>
        <ul className={listClass}>
          <li>Fulfill the purposes outlined in this policy</li>
          <li>Comply with legal, accounting, or reporting requirements</li>
          <li>Resolve disputes and enforce agreements</li>
        </ul>
        <p className="text-[#1F2937] mb-6">
          Typically, we retain business information for 7 years as required by Indian tax and business regulations.
        </p>
      </>
    ),
  },
  {
    title: '8. Third-Party Links',
    content: (
      <p className="text-[#1F2937] mb-6">
        Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
      </p>
    ),
  },
  {
    title: "9. Children's Privacy",
    content: (
      <p className="text-[#1F2937] mb-6">
        Our services are intended for business use only. We do not knowingly collect information from individuals under 18 years of age.
      </p>
    ),
  },
  {
    title: '10. International Data Transfers',
    content: (
      <p className="text-[#1F2937] mb-6">
        As we work with international clients, your information may be transferred to and processed in countries other than India. We ensure appropriate safeguards are in place for such transfers.
      </p>
    ),
  },
  {
    title: '11. Changes to Privacy Policy',
    content: (
      <p className="text-[#1F2937] mb-6">
        We may update this Privacy Policy periodically. Changes will be posted on this page with an updated effective date. Continued use of our services after changes constitutes acceptance.
      </p>
    ),
  },
  {
    title: '12. Contact Us',
    content: (
      <>
        <p className="text-[#1F2937] mb-2">For privacy-related questions or to exercise your rights:</p>
        <div className="bg-[#fafaf9] p-6 rounded-lg border border-[#0B2A57]/10 mb-6">
          <p className="text-[#1F2937]"><strong>Taiga Sourcing</strong></p>
          <p className="text-[#1F2937]">Privacy Officer</p>
          <p className="text-[#1F2937]">603-605, IFC Surana, VIP Road, Vesu</p>
          <p className="text-[#1F2937]">Surat, Gujarat 395007, India</p>
          <p className="text-[#1F2937] mt-2">Email: info@taigasourcing.com</p>
          <p className="text-[#1F2937]">Phone: +91 80999 75662</p>
        </div>
      </>
    ),
  },
];

export default privacyPolicyData;
